<script setup lang="ts">
const props = defineProps({
  error: Object,
});

const state = ref({
  title: "Pagina non trovata",
  text: "La pagina richiesta non è stata trovata",
  icon: "mdi-cloud-remove-outline",
});

if (props.error) {
  switch (props.error.statusCode) {
    case 500:
      state.value = {
        title: "Qualcosa è andato storto",
        icon: "mdi-skull-outline",
        text: import.meta.dev
          ? props.error.message
          : "Ci dispiace per l'inconveniente",
      };
      break;
  }
}
</script>

<template>
  <div
    class="tw-text-tbase tw-w-screen tw-h-screen tw-bg-surface tw-flex tw-justify-center tw-items-center"
  >
    <v-empty-state color="primary" v-bind="state"></v-empty-state>
  </div>
</template>
